const useDatePicker = () => {
    const textInputFormat = {
        format: "dd/MM/yyyy - dd/MM/yyyy ",
    };
    const handleRangeData = (value, dataRef) => {
        if (!dataRef || dataRef.value === undefined) {
            console.error("dataRef must be a ref");
            return false;
        }
        if (!value) return;

        if (value.length === 2) {
            dataRef.value["start"] = value[0];
            dataRef.value["end"] = value[1];
        } else {
            dataRef.value = value;
        }
        return true;
    };

    return {
        textInputFormat,
        handleRangeData,
    };
};
export default useDatePicker;
